import { render, staticRenderFns } from "./takeoutSideboardOrder.vue?vue&type=template&id=3603fef7&scoped=true&"
import script from "./takeoutSideboardOrder.vue?vue&type=script&lang=js&"
export * from "./takeoutSideboardOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3603fef7",
  null
  
)

export default component.exports